var _path, _g, _circle, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 143,
    viewBox: "0 0 152 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.654 51.3112C158.277 81.4508 146.249 120.696 123.996 135.702C101.742 150.579 69.5053 141.217 42.6813 121.081C15.8572 100.945 -5.31337 70.1645 1.18214 44.7702C7.67766 19.376 41.8393 -0.503305 74.6777 0.00970933C107.516 0.39447 138.911 21.2998 148.654 51.3112Z",
    fill: "#EEF1F9",
    fillOpacity: 0.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.583 31C71.4534 31 51.2236 83 46 109L110.108 108.439H117.232C121.41 108.439 122.139 101.705 121.98 98.3381V42.7842C121.98 32.9079 121.031 31 114.857 31H110.583Z",
    fill: "#EEF3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.583 26.6665H106.75C105.692 26.6665 104.833 27.5252 104.833 28.5832C104.833 29.6412 105.692 30.4998 106.75 30.4998H110.583C115.869 30.4998 120.167 34.797 120.167 40.083V97.583C120.167 102.869 115.869 107.166 110.583 107.166H45.4167C40.1305 107.166 35.8335 102.869 35.8335 97.583V40.083C35.8333 34.797 40.1305 30.4998 45.4167 30.4998H49.25C50.308 30.4998 51.1667 29.6411 51.1667 28.5831C51.1667 27.5251 50.308 26.6665 49.25 26.6665H45.4167C38.0183 26.6665 32 32.6848 32 40.083V97.583C32 104.981 38.0183 111 45.4167 111H110.583C117.982 111 124 104.981 124 97.583V40.083C124 32.6848 117.982 26.6665 110.583 26.6665Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4167 26.6665H64.5832C63.5252 26.6665 62.6665 27.5252 62.6665 28.5832C62.6665 29.6412 63.5252 30.4998 64.5832 30.4998H91.4165C92.4745 30.4998 93.3332 29.6411 93.3332 28.5831C93.3332 27.5251 92.4747 26.6665 91.4167 26.6665Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.583 45.833L35.5001 45.8331C34.4421 45.8331 33.5834 46.6919 33.5834 47.7499C33.5834 48.8079 34.4421 49.6666 35.5001 49.6666L101.583 49.6665C102.641 49.6665 103.5 48.8077 103.5 47.7497C103.5 46.6917 102.641 45.833 101.583 45.833Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 23C55.896 23 55 23.8928 55 24.5C55 25.1072 55 32.5 55 32.5C55 33.1072 55.896 34 57 34C58.104 34 59 33.1072 59 32.5C59 32.5 59.0002 25.1072 59 24.5C58.9998 23.8928 58.104 23 57 23Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 23C97.896 23 97 23.8928 97 24.5V32.5C97 33.1072 97.896 34 99 34C100.104 34 101 33.1072 101 32.5V24.5C101 23.8928 100.104 23 99 23Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.875 80.5498C69.4628 80.5498 70.75 79.2626 70.75 77.6748C70.75 76.087 69.4628 74.7998 67.875 74.7998C66.2872 74.7998 65 76.087 65 77.6748C65 79.2626 66.2872 80.5498 67.875 80.5498Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.875 80.5498C86.4628 80.5498 87.75 79.2626 87.75 77.6748C87.75 76.087 86.4628 74.7998 84.875 74.7998C83.2872 74.7998 82 76.087 82 77.6748C82 79.2626 83.2872 80.5498 84.875 80.5498Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.875 80.5498C103.463 80.5498 104.75 79.2626 104.75 77.6748C104.75 76.087 103.463 74.7998 101.875 74.7998C100.287 74.7998 99 76.087 99 77.6748C99 79.2626 100.287 80.5498 101.875 80.5498Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.875 66.75C52.4628 66.75 53.75 65.4628 53.75 63.875C53.75 62.2872 52.4628 61 50.875 61C49.2872 61 48 62.2872 48 63.875C48 65.4628 49.2872 66.75 50.875 66.75Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.875 80.5498C52.4628 80.5498 53.75 79.2626 53.75 77.6748C53.75 76.087 52.4628 74.7998 50.875 74.7998C49.2872 74.7998 48 76.087 48 77.6748C48 79.2626 49.2872 80.5498 50.875 80.5498Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.875 93.2002C52.4628 93.2002 53.75 91.913 53.75 90.3252C53.75 88.7374 52.4628 87.4502 50.875 87.4502C49.2872 87.4502 48 88.7374 48 90.3252C48 91.913 49.2872 93.2002 50.875 93.2002Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.875 93.2002C69.4628 93.2002 70.75 91.913 70.75 90.3252C70.75 88.7374 69.4628 87.4502 67.875 87.4502C66.2872 87.4502 65 88.7374 65 90.3252C65 91.913 66.2872 93.2002 67.875 93.2002Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.875 93.2002C86.4628 93.2002 87.75 91.913 87.75 90.3252C87.75 88.7374 86.4628 87.4502 84.875 87.4502C83.2872 87.4502 82 88.7374 82 90.3252C82 91.913 83.2872 93.2002 84.875 93.2002Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.875 66.75C69.4628 66.75 70.75 65.4628 70.75 63.875C70.75 62.2872 69.4628 61 67.875 61C66.2872 61 65 62.2872 65 63.875C65 65.4628 66.2872 66.75 67.875 66.75Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.875 66.75C86.4628 66.75 87.75 65.4628 87.75 63.875C87.75 62.2872 86.4628 61 84.875 61C83.2872 61 82 62.2872 82 63.875C82 65.4628 83.2872 66.75 84.875 66.75Z",
    fill: "#ACC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.875 66.75C103.463 66.75 104.75 65.4628 104.75 63.875C104.75 62.2872 103.463 61 101.875 61C100.287 61 99 62.2872 99 63.875C99 65.4628 100.287 66.75 101.875 66.75Z",
    fill: "#ACC1D4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 106,
    r: 17,
    fill: "#EEF3F9",
    stroke: "#ACC1D4",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 98V106H125",
    stroke: "#ACC1D4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(32 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEmptyState);
export default __webpack_public_path__ + "static/media/calendarEmptyState.0b94ab0a.svg";
export { ForwardRef as ReactComponent };